var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.article)?_c('ArticleLink',{attrs:{"article":_vm.article}},[_vm._t("default")],2):_c('a',{attrs:{"title":`Artikel #${_vm.id} wurde nicht gefunden`}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }